import React, {useState, useCallback, useMemo} from "react"
import {Paper, Box, useTheme} from "@mui/material"
import {useNavigate, useOutletContext} from "react-router-dom"
import {ReactComponent as CheckIcon} from "src/v2/assets/icons/check-icon.svg"
import FormActions from "../../components/FormActions"
import {dispatchSnackbar} from "../../../../components/SnackBar/snackbar-bus"
import MotorEventosOrdinariosService from "src/services/motor-eventos-ordinarios-service"
import Loader from "src/v2/components/Loader/loader"
import LoaderOverlay from "src/v2/components/LoaderOverlay/loader-overlay"
import EventosOrdinariosTable from "./components/eventos-ordinarios/eventos-ordinarios-table"
import FormSectionAccordion from "../../../../components/FormSectionAccordion"
import DataAniversarioTable from "./components/data-aniversario/data-aniversario-table"
import {mapEventosOrdinariosPayload} from "./components/eventos-ordinarios/map-eventos-ordinarios"
import {toInt} from "../../utils/convert-fields"
import MotorDataAniversarioService from "src/services/motor-data-aniversario-service"
import PremioTable from "./components/premio/premio-table"
import {mapPremioPayload} from "./components/premio/premio-fields"
import MotorPremioService from "../../../../../services/motor-premio-service"
import {mapDataAniversarioPayload} from "./components/data-aniversario/data-aniversario-fields"
import RecompraTable from "./components/recompra-programada/recompra-programada-table"
import {mapRecompraProgramadaPayload} from "./components/recompra-programada/recompra-programada-fields"
import ConversabilidadeTable from "./components/conversibilidade/conversabilidade-table"
import {mapConversibilidadePayload} from "./components/conversibilidade/conversabilidade-fields"

const TABLE_DATA_DEFAULT = [{}]
const INDEXADORES_DATA_ANIVERSARIO = [
    "INCC",
    "TR",
    "IPC_FIPE",
    "IPCA",
    "INPC",
    "INCC_DI",
    "IGPDI",
    "IGPM"
]

export const EventosOrdinariosPage = () => {
    const eventosService = useMemo(() => new MotorEventosOrdinariosService(), [])
    const dataAniversarioService = useMemo(() => new MotorDataAniversarioService(), [])
    const premioService = useMemo(() => new MotorPremioService(), [])
    const theme = useTheme()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [tableEventosData, setTableEventosData] = useState(TABLE_DATA_DEFAULT)
    const [tableAniversarioData, setTableAniversarioData] = useState(TABLE_DATA_DEFAULT)
    const [tablePremioData, setTablePremioData] = useState(TABLE_DATA_DEFAULT)
    const [tableRecompraProgramadaData, setTableRecompraProgramadaData] = useState(TABLE_DATA_DEFAULT)
    const [tableConversibilidadeData, setTableConversibilidadeData] = useState(TABLE_DATA_DEFAULT)
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)
    const [publishConfirmOpen, setPublishConfirmOpen] = useState(false)
    const [showDataAniversario, setShowDataAniversario] = useState(false)

    const {parametrosInfo, eventosPublicado, setEventosPublicado} = useOutletContext() || {}
    const isPublished = eventosPublicado
    const idCaracteristica = parametrosInfo?.idCaracteristica

    const handleSave = async () => {
        const cetip = parametrosInfo?.cetip || ""
        const versaoDocumento = toInt(parametrosInfo?.versaoDocumento) || 0

        const eventosMapeados = mapEventosOrdinariosPayload(tableEventosData)
        const dataAniversarioMapeados = mapDataAniversarioPayload(tableAniversarioData, cetip, versaoDocumento, idCaracteristica)
        const premioMapeados = mapPremioPayload(tablePremioData, cetip, versaoDocumento, idCaracteristica)

        if (eventosMapeados.length === 0) {
            dispatchSnackbar("Preencha ao menos um campo para salvar", "warning")
            return
        }

        const payload = {
            CETIP: cetip,
            VersaoDocumento: versaoDocumento,
            EventosOrdinarios: eventosMapeados
        }

        const payloadDataAniversario = {
            CETIP: cetip,
            VersaoDocumento: versaoDocumento,
            DatasAniversario: dataAniversarioMapeados
        }

        const payloadPremio = {
            CETIP: cetip,
            VersaoDocumento: versaoDocumento,
            Premios: premioMapeados
        }

        try {
            setLoading(true)
            const saveResponse = await eventosService.createCadastroTemporarioEventosOrdinarios(idCaracteristica, payload)

            if (dataAniversarioMapeados.length > 0) {
                await dataAniversarioService.createCadastroTemporarioDataAniversario(idCaracteristica, payloadDataAniversario)
            }
            if (premioMapeados.length > 0) {
                await premioService.createCadastroTemporarioPremio(idCaracteristica,  payloadPremio)
            }

            const mensagem = saveResponse?.body?.mensagem ?? "Salvo com sucesso!"
            dispatchSnackbar(mensagem, "success")
        } catch (error) {
            console.error(error)
            const data =
                error?.response?.body ||
                error?.response?.data ||
                error?.response?.text

            const eventos = data?.EventosOrdinarios
            if (Array.isArray(eventos)) {
                const mensagens = eventos.flatMap(item =>
                    Object.entries(item).flatMap(([campo, erros]) =>
                        erros.map(msg => `${campo} : ${msg}`)
                    )
                )
                dispatchSnackbar(mensagens.join(" | "), "error")
                return
            }

            dispatchSnackbar("Erro ao salvar", "error")
        } finally {
            setLoading(false)
        }
    }

    const handlePublish = async () => {
        setLoading(true)
        const eventosMapeados = mapEventosOrdinariosPayload(tableEventosData)
        const aniversarioMapeados = mapDataAniversarioPayload(tableAniversarioData)
        const premioMapeados = mapPremioPayload(tablePremioData)
        const recompraProgramadaMapeados = mapRecompraProgramadaPayload(tableRecompraProgramadaData)
        const conversibilidadeMapeados = mapConversibilidadePayload(tableConversibilidadeData)

        console.log(aniversarioMapeados)
        console.log(premioMapeados)
        console.log(recompraProgramadaMapeados)
        console.log(conversibilidadeMapeados)
        // todo: adicionar aqui as chamadas para publicar os eventos de data aniversario

        if (eventosMapeados.length === 0) {
            dispatchSnackbar("Preencha ao menos um campo para publicar", "warning")
            return
        }

        const cetip = parametrosInfo?.cetip || ""
        const versaoDocumento = toInt(parametrosInfo?.versaoDocumento) || 0
        const dataAniversarioMapeados = mapDataAniversarioPayload(
            tableAniversarioData,
            cetip,
            versaoDocumento
        )

        const payloadDataAniversario = {
            CETIP: cetip,
            VersaoDocumento: versaoDocumento,
            DatasAniversario: dataAniversarioMapeados
        }

        try {
            const hasProducaoId = eventosPublicado
            if (hasProducaoId) {
                await eventosService.updateCadastroEventosOrdinarios(
                    idCaracteristica,
                    eventosMapeados
                )
            } else {
                await eventosService.createCadastroEventosOrdinarios(
                    idCaracteristica,
                    eventosMapeados
                )
            }

            if (showDataAniversario && dataAniversarioMapeados.length > 0) {
                if (hasProducaoId) {
                    await dataAniversarioService.updateCadastroDataAniversario(
                        idCaracteristica,
                        dataAniversarioMapeados
                    )
                } else {
                    await dataAniversarioService.createCadastroDataAniversario(
                        idCaracteristica,
                        payloadDataAniversario
                    )
                }
            }

            dispatchSnackbar(
                hasProducaoId
                    ? "Cadastro atualizado em produção com sucesso."
                    : "Cadastro publicado com sucesso.",
                "success"
            )
            setEventosPublicado(true)
        } catch (error) {
            const data =
                error?.response?.body ||
                error?.response?.data ||
                error?.response?.text

            if (Array.isArray(data)) {
                const mensagens = data.flatMap(item =>
                    Object.entries(item).flatMap(([campo, erros]) =>
                        erros.map(msg => `${campo} : ${msg}`)
                    )
                )
                dispatchSnackbar(mensagens.join(" | "), "error")
                return
            }

            const message =
                data?.detail ||
                data?.message ||
                error?.message ||
                "Falha ao publicar eventos."

            dispatchSnackbar(message, "error")
        } finally {
            setLoading(false)
            setPublishConfirmOpen(false)
        }
    }

    const handleDelete = useCallback(async () => {
        try {
            setLoading(true)

            if (!idCaracteristica) return
            const isProducao = eventosPublicado

            if (isProducao) {
                await eventosService.deleteCadastroEventosOrdinarios(idCaracteristica)
            } else {
                await eventosService.deleteCadastroTemporarioEventosOrdinarios(idCaracteristica)
            }

            if (showDataAniversario) {
                if (isProducao) {
                    await dataAniversarioService.deleteCadastroDataAniversario(idCaracteristica)
                } else {
                    await dataAniversarioService.deleteCadastroTemporarioDataAniversario(idCaracteristica)
                }
            }

            setTableEventosItem(TABLE_DATA_DEFAULT)
            setEventosPublicado(false)

            dispatchSnackbar(
                isProducao
                    ? "Cadastro deletado com sucesso."
                    : "Cadastro temporário deletado com sucesso.",
                "success"
            )

        } catch (error) {
            dispatchSnackbar("Erro ao deletar cadastro.", "error")
        } finally {
            setLoading(false)
            setDeleteConfirmOpen(false)
        }
    }, [idCaracteristica, eventosPublicado, eventosService])

    const clearTable = (setClearFunction) => {
        setClearFunction(TABLE_DATA_DEFAULT)
    }

    const activeDataAniversario = (value) => {
        if (value) {
            dispatchSnackbar("Avaliar aplicabilidade de preenchimento de Data Aniversário", "warning")
        }
        setShowDataAniversario(value)
    }

    const setTableEventosItem = (data) => {
        setTableEventosData(data)
        const indexadorFound = data.some(item =>
            INDEXADORES_DATA_ANIVERSARIO.includes(item.Indexador)
        )
        if (!showDataAniversario && indexadorFound) {
            activeDataAniversario(true)
            return
        }
        activeDataAniversario(false)
    }

    return (
        <>
            {loading && (
                <LoaderOverlay>
                    <Loader/>
                </LoaderOverlay>
            )}

            <Paper sx={{p: 2, pl: 4, pr: 4, mb: (showDataAniversario ? 0 : 2)}}>
                <EventosOrdinariosTable
                    eventosProjetados={location.state?.eventos}
                    idCaracteristica={idCaracteristica}
                    setLoading={setLoading}
                    tableData={tableEventosData}
                    clearTable={clearTable}
                    eventoPublicado={setEventosPublicado}
                    setTableData={setTableEventosItem}
                />
            </Paper>

            {showDataAniversario && (
                <Box sx={{mt: 2, mb: 2}}>
                    <FormSectionAccordion
                        title="Data Aniversário"
                        defaultOpen={true}
                        disableBorder={true}
                    >
                        <DataAniversarioTable
                            setLoading={setLoading}
                            idCaracteristica={idCaracteristica}
                            eventoPublicado={() => {
                            }}
                            showDataAniversario={showDataAniversario}
                            datasProjetadas={location.state?.dataAniversario}
                            tableData={tableAniversarioData}
                            setTableData={setTableAniversarioData}
                            clearTable={clearTable}
                        />
                    </FormSectionAccordion>
                </Box>
            )}

            <Box sx={{mb: 2}}>
                <FormSectionAccordion
                    title="Prêmio"
                    defaultOpen={true}
                    disableBorder={true}
                >
                    <PremioTable
                        setLoading={setLoading}
                        idCaracteristica={idCaracteristica}
                        eventoPublicado={() => {}}
                        datasProjetadas={location.state?.premio}
                        tableData={tablePremioData}
                        setTableData={setTablePremioData}
                        clearTable={clearTable}
                    />
                </FormSectionAccordion>
            </Box>

            <Box sx={{mb: 2}}>
                <FormSectionAccordion
                    title="Recompra Programada"
                    defaultOpen={true}
                    disableBorder={true}
                >
                    <RecompraTable
                        setLoading={setLoading}
                        idCaracteristica={idCaracteristica}
                        eventoPublicado={() => {}}
                        datasProjetadas={location.state?.recompraProgramada}
                        tableData={tableRecompraProgramadaData}
                        setTableData={setTableRecompraProgramadaData}
                        clearTable={clearTable}
                    />
                </FormSectionAccordion>
            </Box>

            <Box sx={{mb: 8}}>
                <FormSectionAccordion
                    title="Conversibilidade"
                    defaultOpen={true}
                    disableBorder={true}
                >
                    <ConversabilidadeTable
                        setLoading={setLoading}
                        idCaracteristica={idCaracteristica}
                        eventoPublicado={() => {}}
                        datasProjetadas={location.state?.conversibilidade}
                        tableData={tableConversibilidadeData}
                        setTableData={setTableConversibilidadeData}
                        clearTable={clearTable}
                    />
                </FormSectionAccordion>
            </Box>

            <Box sx={{mx: {xxxs: -3, md: -3, lg: 0}, mt: 4}}>
                <FormActions
                    showBack
                    onBack={() => navigate(-1)}
                    onDelete={() => setDeleteConfirmOpen(true)}
                    deleteOpen={deleteConfirmOpen}
                    setDeleteOpen={setDeleteConfirmOpen}
                    onConfirmDelete={handleDelete}
                    showSave={!isPublished}
                    onSave={!loading ? handleSave : undefined}
                    onPublish={() => setPublishConfirmOpen(true)}
                    publishOpen={publishConfirmOpen}
                    setPublishOpen={setPublishConfirmOpen}
                    onConfirmPublish={handlePublish}
                    publishLabel={isPublished ? "SALVAR E PUBLICAR" : "PUBLICAR"}
                    publishIcon={<CheckIcon/>}
                    theme={theme}/>
            </Box>
        </>
    )
}
